import { render } from "./CustomersDashboard.vue?vue&type=template&id=1e85cb24&scoped=true&lang=pug"
import script from "./CustomersDashboard.vue?vue&type=script&lang=js"
export * from "./CustomersDashboard.vue?vue&type=script&lang=js"

import "./CustomersDashboard.vue?vue&type=style&index=0&id=1e85cb24&lang=scss&scoped=true"
import "./CustomersDashboard.vue?vue&type=style&index=1&id=1e85cb24&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e85cb24"]])

export default __exports__